<template>
  <div
    class="label-frame d-flex align-center justify-center px-3 cursor-pointer"
    :style="{'height': height}"
    @click="eventClick"
  >
    <span
            class="text-uppercase white--text bold"
            style="white-space: nowrap;"
            :style="{ 'font-size': $vuetify.breakpoint.xs ? '14px':'16px' }"
    >{{name}}</span>
  </div>
</template>

<script>
export default {
  props: {
    name: {
      type: String,
      default: ""
    },
    height: {
      type: String,
      default: "34px"
    }
  },
  methods: {
    eventClick() {
      this.$emit('onPress');
    }
  }
};
</script>

<style lang="scss">
.label-frame {
  background-color: $tcdcGreen;
  border-radius: 100px;
}
</style>
